import { createGradientOrSolid } from "../../Helper/utils";
import styled from "styled-components";

export const StyledSpecialOffer = styled.div`
    max-width: 400px;
    width: 100%;
    padding: 4px;
    min-height: 269px;
    aspect-ratio: 3/2.25;
    background: ${(props: any) => createGradientOrSolid(props.borderColor)};
    border-radius: 15px;
    font-family: ${(props: any) => props.fontFamily};
    z-index: 1;
    position: relative;

    .backgroundImage {
        width: 100%;
        height: 100%;
        padding: ${(props: any) => props.boxPadding};
        border-radius: 10px;
        background: ${(props: any) =>
            props.backgroundImage
                ? `url("${props.backgroundImage}")`
                : createGradientOrSolid(props.backgroundColor)};
        background-size: cover;
        background-position: center;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
    }

    h2 {
        background: ${(props: any) => createGradientOrSolid(props.textColor)};
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin: 0;
        font-size: 24px;
        position: relative;

        &:after {
            background: none;
            content: "${(props: any) => props.title}";
            left: 0;
            top: 0;
            z-index: -1;
            position: absolute;
            text-shadow: 0 2px 0px #000000;
        }
    }

    .productsContainer {
        width: 90%;
        height: ${(props: any) => props.productsHeight};
        border-radius: 15px;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        z-index: 1;

        .products {
            display: flex;
            justify-content: center;
            gap: 1em;
            height: ${(props: any) => props.mainHeight};
            max-width: 100%;

            .product {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                max-width: 20%;
    
                img {
                    height: 55%;
                    object-fit: contain;
                }
                h4 {
                    font-size: 12px;
                    margin: 4px 0 0 0;
                }
            }
        }

        .secondaryProduct {
            height: 39%;
            .product h4 {
                color: white;
                font-size: 12px;
            }
        }

        .mainProducts h4 {
            background: linear-gradient(to bottom, rgb(255, 247, 199), rgb(226, 182, 109));
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            position: relative;

            &:after {
                background: none;
                content: attr(data-text);
                left: 0;
                top: 0;
                z-index: -1;
                position: absolute;
                text-shadow: 0 2px 0px #000000;
            }
        }

        .divider {
            width: 85%;
            height: 1%;
            background-color: white;
        }
    }

    span {
        margin: 4px 0;
        color: white;
        text-shadow: 0px 2px 0px black;

        &.availability {
            font-size: 12px;
            position: absolute;
            bottom: 10px;

            &.countdown {
                right: 8px;
            }

            &.quantity {
                left: 8px;
            }
        }
    }
` as any;
